import { render, staticRenderFns } from "./CategoryBanners.vue?vue&type=template&id=95b4a5c4&scoped=true&"
import script from "./CategoryBanners.vue?vue&type=script&lang=js&"
export * from "./CategoryBanners.vue?vue&type=script&lang=js&"
import style0 from "./CategoryBanners.vue?vue&type=style&index=0&id=95b4a5c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b4a5c4",
  null
  
)

export default component.exports